export enum ENUM__control_net_mode {
  BALANCED = 'balanced',
  MORE_PROMPT = 'more_prompt',
  MORE_CONTROL = 'more_control',
  UNBALANCED = 'unbalanced',
}
